import { render, staticRenderFns } from "./DataWidget.vue?vue&type=template&id=39489b5d&scoped=true&"
import script from "./DataWidget.vue?vue&type=script&lang=js&"
export * from "./DataWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39489b5d",
  null
  
)

export default component.exports